import {AsyncPipe} from "@angular/common";
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FlexModule} from "@angular/flex-layout";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {LoadingService} from "@ui-kit/framework/util/service/loading.service";

@Component({
  selector: 'app-confirm-remove',
  standalone: true,
  templateUrl: './confirm-remove.component.html',
  imports: [
    FlexModule,
    MatButtonModule,
    MatIconModule,
    AsyncPipe
  ],
  styleUrls: ['./confirm-remove.component.scss']
})
export class ConfirmRemoveComponent {
  @Input() message: string = 'Do you want to remove the selected item(s)?';
  @Input() buttonLabel1: string = 'Yes';
  @Input() buttonLabel2: string = 'No';
  @Input() buttonDisabled1: boolean = false;
  @Input() buttonDisabled2: boolean = false;

  @Output() confirmRemove = new EventEmitter<boolean>();

  loading$ = this.loader.loading$;

  constructor(private loader: LoadingService) {
  }

  removeItems(confirm: boolean) {
    this.confirmRemove.emit(confirm);
  }

}
